module.exports = __webpack_public_path__ + "static/img/miPad4.3e988685.png";